import { render, staticRenderFns } from "./JdsDropdownMenuItem.vue?vue&type=template&id=696ac8a7&scoped=true&"
import script from "./JdsDropdownMenuItem.vue?vue&type=script&lang=ts&"
export * from "./JdsDropdownMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./JdsDropdownMenuItem.vue?vue&type=style&index=0&id=696ac8a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696ac8a7",
  null
  
)

export default component.exports